import axiosInstance from "core/api/axiosInstance";
import { getCommerceId } from "./authService";

// Obtener todos los usuarios del comercio actual
export const getUsuariosParqueaderoService = async () => {
  try {
    const commerceId = getCommerceId();

    if (!commerceId) {
      return {
        success: false,
        error: "No se encontró un comercio asociado al usuario",
        data: [],
        total: 0,
        activeCount: 0,
        expiredCount: 0,
      };
    }

    const { data } = await axiosInstance.get(
      `/api/automatization/cbrs/co_prop/users/${commerceId}`
    );

    if (!data || typeof data !== "object") {
      return {
        success: false,
        error: "Respuesta inválida del servidor",
        data: [],
        total: 0,
        activeCount: 0,
        expiredCount: 0,
      };
    }

    const recordsArray = Array.isArray(data.data) ? data.data : [];

    const processedData = recordsArray.map((user) => ({
      id: user.id,
      plate: user.plate || "",
      name: user.name || "",
      lastname: user.last_name || "",
      cedula: user.identification || "",
      residential: user.residential || "",
      start_date: user.date_init || "",
      end_date: user.date_end || "",
      idvehicletype: user.vehicle_type === "11" ? 2 : 1,
      UserGoper: user.user_update || "",
      config: user.config || "",
    }));

    const now = new Date();
    const activeCount = processedData.filter((u) => new Date(u.end_date) > now).length;

    return {
      success: true,
      data: processedData,
      total: processedData.length,
      activeCount: activeCount,
      expiredCount: processedData.length - activeCount,
      message: data.msm || "Usuarios obtenidos exitosamente",
    };
  } catch (error) {
    console.error("❌ Error al obtener usuarios:", error);
    return {
      success: false,
      error: error.message || "Error al obtener usuarios",
      data: [],
      total: 0,
      activeCount: 0,
      expiredCount: 0,
    };
  }
};

// Crear un nuevo usuario
export const createUsuarioParqueaderoService = async (usuarioData) => {
  try {
    const commerceId = getCommerceId();

    if (!commerceId) {
      return {
        success: false,
        error: "No se encontró un comercio asociado al usuario",
      };
    }

    const idCommerce = Number(commerceId);
    if (isNaN(idCommerce) || idCommerce <= 0) {
      return {
        success: false,
        error: "ID de comercio inválido",
      };
    }

    const payload = {
      id_commerce: idCommerce,
      name: usuarioData.name,
      last_name: usuarioData.lastname,
      plate: usuarioData.plate.toUpperCase(),
      identification: usuarioData.cedula,
      vehicle_type: usuarioData.idvehicletype === 2 ? "11" : "1",
      residential: usuarioData.residential,
      date_init: usuarioData.start_date.replace("T", " "),
      date_end: usuarioData.end_date.replace("T", " "),
      config: "{}",
    };

    const { data } = await axiosInstance.post(
      "/api/automatization/cbrs/co_prop/user-create",
      payload
    );

    if (data && data.msm === "succesful") {
      const newUser = {
        id: data.data?.id || Date.now(),
        plate: payload.plate,
        name: payload.name,
        lastname: payload.last_name,
        cedula: payload.identification,
        residential: payload.residential,
        start_date: payload.date_init,
        end_date: payload.date_end,
        idvehicletype: usuarioData.idvehicletype,
        UserGoper: usuarioData.UserGoper || "",
        config: payload.config,
      };

      return {
        success: true,
        data: newUser,
        message: "Usuario creado exitosamente",
      };
    } else {
      const errorMsg =
        data?.message || data?.data?.error || data?.msm || "Error al crear el usuario";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al crear usuario:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al crear el usuario";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

// Actualizar un usuario existente
export const updateUsuarioParqueaderoService = async (usuarioData) => {
  try {
    const commerceId = getCommerceId();

    if (!commerceId) {
      return {
        success: false,
        error: "No se encontró un comercio asociado al usuario",
      };
    }

    const idCommerce = Number(commerceId);
    if (isNaN(idCommerce) || idCommerce <= 0) {
      return {
        success: false,
        error: "ID de comercio inválido",
      };
    }

    const payload = {
      id_commerce: idCommerce,
      id: usuarioData.id,
      name: usuarioData.name,
      last_name: usuarioData.lastname,
      plate: usuarioData.plate.toUpperCase(),
      identification: usuarioData.cedula,
      vehicle_type: usuarioData.idvehicletype === 2 ? "11" : "1",
      residential: usuarioData.residential,
      date_init: usuarioData.start_date.replace("T", " "),
      date_end: usuarioData.end_date.replace("T", " "),
      config: usuarioData.config || "{}",
    };

    const { data } = await axiosInstance.put(
      "/api/automatization/cbrs/co_prop/user-update",
      payload
    );

    if (data && data.msm === "succesful") {
      return {
        success: true,
        data: usuarioData,
        message: "Usuario actualizado exitosamente",
      };
    } else {
      const errorMsg =
        data?.message || data?.data?.error || data?.msm || "Error al actualizar el usuario";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al actualizar usuario:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al actualizar el usuario";
    return {
      success: false,
      error: errorMsg,
    };
  }
};

// Eliminar un usuario - CORREGIDO según el endpoint
export const deleteUsuarioParqueaderoService = async (id, plate) => {
  try {
    const commerceId = getCommerceId();

    if (!commerceId) {
      return {
        success: false,
        error: "No se encontró un comercio asociado al usuario",
      };
    }

    const idCommerce = Number(commerceId);
    if (isNaN(idCommerce) || idCommerce <= 0) {
      return {
        success: false,
        error: "ID de comercio inválido",
      };
    }

    // El payload debe tener el orden: id_commerce, id, plate
    const payload = {
      id_commerce: idCommerce,
      id: id,
      plate: plate,
    };

    const { data } = await axiosInstance.delete("/api/automatization/cbrs/co_prop/user-delete", {
      data: payload,
    });

    if (data && data.msm === "succesful") {
      return {
        success: true,
        message: "Usuario eliminado exitosamente",
      };
    } else {
      const errorMsg =
        data?.message || data?.data?.error || data?.msm || "Error al eliminar el usuario";
      console.error("❌ Error del servidor:", errorMsg);
      return {
        success: false,
        error: errorMsg,
      };
    }
  } catch (error) {
    console.error("❌ Error al eliminar usuario:", error);
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.data?.error ||
      error.message ||
      "Error al eliminar el usuario";
    return {
      success: false,
      error: errorMsg,
    };
  }
};
